import { authApp } from '@/services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Observable } from 'rxjs';
export const auth$ = new Observable((subscriber) => {
    const unsubscribe = onAuthStateChanged(authApp, subscriber);
    return { unsubscribe };
});
